import React from 'react';
import Hero from './ui/Hero.js';
import image3 from './../assets/images/image3.png';
import { whoCanAssociate, benefitsOfPartnering } from '../constant.js';
import BenefitsSection from './ui/BenefitsSection.js';

const BuisnessAssociates = () => {
    return (
        <div style={{ paddingBottom: "30px" }}>
            <Hero className='' img={image3}>
                <h2 style={{
                    background: "var(--primary-gradient-100)",
                    backgroundClip: "text",
                    WebkitTextFillColor: "transparent", marginBottom: "20px"
                }}>Business Associates</h2>
                <p style={{ fontSize: "18px", fontWeight: "400", color: "var(--text-color)", lineHeight: "24px", marginBottom: "30px" }}>
                    <span style={{ fontWeight: "700", fontSize: "20px", lineHeight: "30px" }}>"Become a LibCloud Business Associate and Unlock a World of Opportunities"</span><br /><br />
                    Offer a fully managed, cloud-hosted Koha LMS solution, including the Mobile Application for Koha LMS, to libraries worldwide. Build a profitable business with our support while we handle the technical complexities. Focus on growing your business, and let us take care of the rest. Contact us today to get started!
                </p>
            </Hero>
            <div className='sizedbox mt-5'>
                <h2 style={{ color: "var(--text-color)" }}>Who Can Be&nbsp;
                    <span
                        style={{
                            background: "var(--primary-gradient-100)",
                            backgroundClip: "text",
                            WebkitTextFillColor: "transparent"
                        }}>
                        Associates</span>?</h2>
                <p style={{ fontWeight: "400", fontSize: "20px", lineHeight: "30px", color: "var(--text-color)", marginTop: "-15px" }}>Designed for businesses, not individual libraries, to deliver Koha LMS solutions globally.</p>
                <div className='mt-3 row g-2'>
                    {
                        whoCanAssociate.map((item, index) => (
                            <div className='col-12 col-md-4 text-center p-2 align-items-stretch' >
                                <div
                                    style={{
                                        boxShadow: "0px 4px 5px 0px #00000033",
                                        padding: "20px",
                                        borderRadius: "15px",
                                        alignItems: "center",
                                        height: "100%"
                                    }}
                                >
                                    <img className='mt-2 w-100' src={item.image} alt={item.title}></img>
                                    <h4 className='mt-4 text-center' style={{ fontSize: "24px", fontWeight: "400", color: "var(--text-color)" }}>
                                        {item.title}
                                    </h4>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
            <BenefitsSection title="Benefits for Business Associates" list={benefitsOfPartnering} />

        </div>
    );
}

export default BuisnessAssociates;